import React from "react";

export function PageBackground() {
  return (
    <div style={{ position:"fixed", inset:0, zIndex:0, overflow:"hidden", pointerEvents:"none" }}>
      <div style={{ width:"100%", height:"100%", position:"relative" }}>
        <div style={{ filter:"blur(2.9vw)", transformStyle:"preserve-3d", border:"1.4vw solid rgb(249,0,145)", borderRadius:"0.85vw", width:"125%", height:"98%", marginLeft:"-4%", position:"absolute", transform:"skew(8deg, 356deg)" }} />
      </div>
    </div>
  );
}
